import { render } from "./KubernetesAfterInstallation.vue?vue&type=template&id=815962b6"
import script from "./KubernetesAfterInstallation.vue?vue&type=script&lang=js"
export * from "./KubernetesAfterInstallation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__